module.exports = __webpack_public_path__ + "static/intertec_screen_1-008c1a27e382336cb43d3aafa0800bf3.jpg";